export default __webpack_public_path__ + "static/designer-karl-mccarthy-dd112840c9b5661e7dd95f94a186f415.png";